/* radial-progress-bar.tsx generated by @compiled/babel-plugin v0.38.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "style"],
  _excluded2 = ["as", "style"];
import "./radial-progress-bar.compiled.css";
import { forwardRef } from 'react';
import { ax, ix } from "@compiled/react/runtime";
import React, { useEffect, useRef } from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var Wrapper = forwardRef(function (_ref, __cmplr) {
  var _ref$as = _ref.as,
    C = _ref$as === void 0 ? "div" : _ref$as,
    __cmpls = _ref.style,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_kqswh2mm _1bsbgktf _4t3igktf", __cmplp.className])
  }));
});

// We need to scale the canvas down to increase the sharpness of the circle
// Otherwise the graphics will be blurry
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
if (process.env.NODE_ENV !== 'production') {
  Wrapper.displayName = 'Wrapper';
}
var CanvasWrapper = forwardRef(function (_ref2, __cmplr) {
  var _ref2$as = _ref2.as,
    C = _ref2$as === void 0 ? "div" : _ref2$as,
    __cmpls = _ref2.style,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_kqswstnw _1bsbuuw1 _4t3iuuw1 _154i17hu _1ltv17hu _t9ec185q", __cmplp.className])
  }));
});
if (process.env.NODE_ENV !== 'production') {
  CanvasWrapper.displayName = 'CanvasWrapper';
}
export var RadialProgressBar = function RadialProgressBar(_ref3) {
  var current = _ref3.current,
    max = _ref3.max;
  var canvasRef = useRef(null);

  // Draw the current circle progress bar
  useEffect(function () {
    var _canvasRef$current;
    var ctx = (_canvasRef$current = canvasRef.current) === null || _canvasRef$current === void 0 ? void 0 : _canvasRef$current.getContext('2d');
    if (ctx) {
      if (current >= max) {
        ctx.beginPath();
        ctx.strokeStyle = '#E91618';
        ctx.lineWidth = 20;
        ctx.arc(100, 100, 80, 0, 2 * Math.PI);
        ctx.stroke();
      } else {
        ctx.beginPath();
        ctx.strokeStyle = '#DCDFE4';
        ctx.lineWidth = 20;
        ctx.arc(100, 100, 80, 0, 2 * Math.PI);
        ctx.stroke();
        ctx.beginPath();
        ctx.strokeStyle = '#22A06B';
        ctx.lineWidth = 20;
        ctx.arc(100, 100, 80, -0.5 * Math.PI, 2 * Math.PI * (current / max) - 0.5 * Math.PI);
        ctx.stroke();
      }
    }
  }, [current, max]);
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(CanvasWrapper, null, /*#__PURE__*/React.createElement("canvas", {
    ref: canvasRef,
    height: 200,
    width: 200
  })));
};